import {COUNTRIES_LIST} from './countries';

export const IS_LOCALHOST = window.location.origin.includes('localhost');
export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development';
export const IS_DEMO = process.env.REACT_APP_ENV === 'demo';
export const MAP_TYPE = (process.env.REACT_APP_GEO || 'GOOGLE') as 'GOOGLE' | 'YANDEX';

export type ENVIRONMENTS = 'development' | 'demo' | 'stage' | 'production';

export type COUNTRIES = typeof COUNTRIES_LIST[number];
const COUNTRY_MAP: Record<COUNTRIES, {short: string}> = {
    CAR: {short: 'CF'},
    TJ: {short: 'TJ'},
    NG: {short: 'NG'},
};
export const COUNTRY = process.env.REACT_APP_COUNTRY as COUNTRIES;
export const COUNTRY_NAMING = COUNTRY_MAP[COUNTRY];

const ISO_ALPHA_2_NAMES = {
    CAR: 'CF',
    NG: 'NG',
    TJ: 'TJ',
};
export const ALPHA_2_COUNTRY = ISO_ALPHA_2_NAMES[COUNTRY];

export const IS_NG = process.env.REACT_APP_COUNTRY === 'NG';
export const IS_CAR = process.env.REACT_APP_COUNTRY === 'CAR';
export const IS_TJ = process.env.REACT_APP_COUNTRY === 'TJ';
